const packages = [
  {
    _id: 0,
    label: "Name"
  },
  {
    _id: 1,
    label: "Category"
  },
  {
    _id: 2,
    label: "Location"
  },
  {
    _id: 3,
    label: "Term"
  },
  {
    _id: 4,
    label: "Price"
  },
  {
    _id: 5,
    label: "Schedule"
  },
  {
    _id: 6,
    label: "Status"
  },
  {
    _id: 7,
    label: "Action"
  }
];

const categories = [
  {
    _id: 0,
    label: "Name"
  },
  {
    _id: 1,
    label: "Description"
  },
  {
    _id: 2,
    label: "Type"
  },
  {
    _id: 3,
    label: "Status"
  },
  {
    _id: 4,
    label: "Action"
  }
];

const locations = [
  {
    _id: 0,
    label: "Name"
  },
  {
    _id: 1,
    label: "Address"
  },
  {
    _id: 2,
    label: "Action"
  }
];

const inclusions = [
  {
    _id: 0,
    label: "Name"
  },
  {
    _id: 1,
    label: "Description"
  },
  {
    _id: 2,
    label: "Status"
  },
  {
    _id: 3,
    label: "Action"
  }
];

const terms = [
  {
    _id: 0,
    label: "Name"
  },
  {
    _id: 1,
    label: "Date and Time"
  },
  {
    _id: 2,
    label: "Calculate Duration"
  },
  {
    _id: 3,
    label: "Unit of Calculation"
  },
  {
    _id: 4,
    label: "Status"
  },
  {
    _id: 5,
    label: "Action"
  }
];

const products = [
  {
    _id: 0,
    label: "Name"
  },
  {
    _id: 1,
    label: "Description"
  },
  {
    _id: 2,
    label: "Category"
  },
  {
    _id: 3,
    label: "Location"
  },
  {
    _id: 4,
    label: "Inclusions"
  },
  {
    _id: 5,
    label: "Status"
  },
  {
    _id: 6,
    label: "Action"
  }
];

const bookings = [
  {
    _id: 0,
    label: "Category"
  },
  {
    _id: 1,
    label: "Product"
  },
  {
    _id: 2,
    label: "Paid"
  },
  {
    _id: 3,
    label: "Unpaid"
  },
  {
    _id: 4,
    label: "Cancelled"
  },
  {
    _id: 5,
    label: "Total"
  }
];

const schedules = [
  {
    _id: 0,
    label: "Name"
  },
  {
    _id: 1,
    label: "Days"
  },
  {
    _id: 2,
    label: "Time"
  },
  {
    _id: 3,
    label: "Action"
  }
];

export {
  packages,
  categories,
  products,
  terms,
  locations,
  inclusions,
  bookings,
  schedules
};
